export default {
    root: ({ instance }) => (instance.$attrs.variant === 'secondary' ? 'secondary-tab' : 'primary-tab'),
};
